export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderConversations@3x.png";